var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExtensionFilled = function SvgExtensionFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M21.003 7.275v3.221a2.688 2.688 0 0 0-1.4.091 2.61 2.61 0 0 0-1.688 1.836 2.645 2.645 0 0 0 3.089 3.248v3.22a2.112 2.112 0 0 1-2.112 2.113H15.67c.094-.466.062-.95-.091-1.4a2.61 2.61 0 0 0-1.836-1.688 2.645 2.645 0 0 0-3.248 3.089l-3.22-.001a2.111 2.111 0 0 1-2.112-2.111v-3.221a2.645 2.645 0 0 1-3.088-3.247 2.61 2.61 0 0 1 1.688-1.837c.45-.153.933-.185 1.4-.09V7.275a2.112 2.112 0 0 1 2.111-2.112h3.221a2.645 2.645 0 0 1 3.247-3.088c.859.216 1.55.85 1.837 1.688.153.45.185.933.09 1.4h3.222a2.112 2.112 0 0 1 2.112 2.112",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21.003 7.275v3.221h0a2.688 2.688 0 0 0-1.4.091 2.61 2.61 0 0 0-1.688 1.836 2.645 2.645 0 0 0 3.089 3.248v3.22a2.112 2.112 0 0 1-2.112 2.113H15.67v0c.094-.466.062-.95-.091-1.4a2.61 2.61 0 0 0-1.836-1.688 2.645 2.645 0 0 0-3.248 3.089l-3.22-.001a2.111 2.111 0 0 1-2.112-2.111v-3.221a2.645 2.645 0 0 1-3.088-3.247 2.61 2.61 0 0 1 1.688-1.837c.45-.153.933-.185 1.4-.09h0V7.275a2.112 2.112 0 0 1 2.111-2.112h3.221a2.645 2.645 0 0 1 3.247-3.088c.859.216 1.55.85 1.837 1.688.153.45.185.933.09 1.4h3.222a2.112 2.112 0 0 1 2.112 2.112"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExtensionFilled);
export default ForwardRef;